export default __webpack_public_path__ + "static/media/winner10.3a4ac3d4.jpg";